<template>
    <div class="flex items-center space-x-2">
        <ActivixPill
            :is-active="activePill === pill.name"
            :is-disabled="pill.disabled"
            :label="pill.label"
            :key="pill.name"
            @click="onClick(pill)"
            v-for="pill in pills"
        />
    </div>
</template>

<script>
    import ActivixPill from './Pill.vue';

    /**
     * Create a pills navigation.
     * @displayName Pills
     */
    export default {
        name: 'ActivixPills',

        components: {
            ActivixPill,
        },

        props: {
            pills: {
                type: Array,
                required: true,
            },
            value: {
                required: true,
            },
        },

        data: ({ value }) => ({
            activePill: value,
        }),

        watch: {
            activePill(activePill) {
                this.$emit('input', activePill);
            },

            value(value) {
                if (this.activePill !== value) {
                    this.activePill = value;
                }
            },
        },

        methods: {
            onClick(pill) {
                if (pill.disabled) {
                    return;
                }

                this.activePill = pill.name;
            },
        },

        mounted() {
            if (!this.value) {
                this.activePill = this.pills[0]?.name || null;
            }
        },
    };
</script>
